export enum CampaignAction {
  editCampaign = 'edit-campaign',
  chooseTemplate = 'choose-template',
  editCampaignHTML = 'edit-campaign-html',
}
